import { DynamicStyleSheet, minWidth } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  root: {
    minHeight: 48,
    justifyContent: 'center',
    ...minWidth(theme.breakpoints.tablet, {
      borderRadius: Platform.select({
        ios: theme.radii.ios,
        android: theme.radii.android,
        default: theme.radii.web,
      }),
    }),
  },
  cell: {
    flexGrow: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  before: {
    paddingVertical: 4,
    marginRight: 16,
  },
  main: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingVertical: 12,
  },
  indicator: {
    marginLeft: 8,
    color: theme.colors.textSecondary,
  },
  icon: {
    color: theme.colors.iconPrimary,
  },
  expandableIcon: {
    marginLeft: 8,
    color: theme.colors.iconSecondary,
  },
}));
